<template>
  <div class="default-footer-menu">
    <h4 class="default-footer-menu--title" v-if="config.menu && config.menu.name">
      {{ config.menu.name }}
      <button
        class="d-md-none d-block"
        data-toggle="collapse"
        :data-target="`.default-footer-menu-${onlyKey}`"
        aria-expanded="true"
      >
        <span class="rotate-plus-minus"></span>
      </button>
    </h4>
    <ul
      class="default-footer-menu--items collapse show"
      :class="`default-footer-menu-${onlyKey}`"
      v-if="config.menu && config.menu.items && config.menu && config.menu.items.length"
    >
      <li v-for="item in config.menu.items" :key="item.ID">
        <a :href="item.path" target="_blank"> {{ item.title }} </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    config: {},
  },
  data() {
    return {
      onlyKey: this.randomCoding(),
    }
  },
}
</script>
<style scoped lang='scss'>
* {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}
li {
  list-style: none;
}
.default-footer-menu {
  &--title {
    position: relative;
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #222232;
    font-family: var(--title-font-family);
    color: var(--default-foot-tx-color, black);
    & > button {
      border: none;
      .rotate-plus-minus {
        padding: 15px;
        &::after,
        &::before {
          opacity: 1;
          background-color: var(--default-foot-tx-color, black);
        }
      }
      &[aria-expanded='true'] .rotate-plus-minus {
        &::after,
        &::before {
          -webkit-transform: translate(-50%, -50%) rotate(90deg);
          transform: translate(-50%, -50%) rotate(90deg);
        }
        &::before {
          opacity: 0;
        }
      }
    }
  }
  &--items {
    font-family: var(--text-font-family);
    li {
      font-size: 16px;
      line-height: 24px;
      a {
        color: var(--default-foot-tx-color,#222232);
      }
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }
}
</style>